// src/components/RequirePlan.jsx

import React from 'react';
import { Container, Card, Button, Row, Col } from 'react-bootstrap';
import { FaLock, FaCrown, FaRocket, FaArrowLeft } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import {
  usePlanAccess,
  FEATURES,
  PLAN_LABELS,
  PLAN_COLORS,
} from '../hooks/usePlanAccess';

export default function RequirePlan({ feature, children }) {
  const { tier, hasAccess } = usePlanAccess();
  const navigate = useNavigate();

  if (hasAccess(feature)) return children;

  const cfg          = FEATURES[feature];
  const requiredPlan = cfg?.requiredPlan ?? 'PRO';
  const reqColor     = PLAN_COLORS[requiredPlan];

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col md={8} lg={7}>
          <Card className="shadow-sm border-0 text-center">
            <Card.Body className="p-5">

              <div
                className="d-inline-flex align-items-center justify-content-center mb-4 position-relative"
                style={{
                  width: 100, height: 100, borderRadius: '50%',
                  backgroundColor: `${reqColor}15`,
                  color: reqColor, fontSize: 44,
                }}
              >
                {requiredPlan === 'ENTERPRISE' ? <FaCrown /> : <FaRocket />}
                <span
                  className="position-absolute d-flex align-items-center justify-content-center"
                  style={{
                    bottom: -4, right: -4,
                    width: 36, height: 36, borderRadius: '50%',
                    backgroundColor: '#fff3cd', color: '#664d03',
                    border: '2px solid #ffe69c', fontSize: 16,
                  }}
                >
                  <FaLock />
                </span>
              </div>

              <h2 className="mb-2 fw-bold">{cfg?.label}</h2>
              <p className="text-muted mb-4">{cfg?.description}</p>

              <div className="alert alert-light border d-inline-block px-4 py-3 mb-4">
                <small className="text-muted d-block">Disponível a partir do plano</small>
                <h4 className="mb-0 mt-1 d-flex align-items-center gap-2 justify-content-center"
                    style={{ color: reqColor }}>
                  {requiredPlan === 'ENTERPRISE' ? <FaCrown /> : <FaRocket />}
                  {PLAN_LABELS[requiredPlan]}
                </h4>
                <small className="text-muted d-block mt-2">
                  Seu plano atual: <strong>{PLAN_LABELS[tier]}</strong>
                </small>
              </div>

              <div className="d-flex gap-2 justify-content-center flex-wrap">
                <Button variant="outline-secondary" onClick={() => navigate(-1)}>
                  <FaArrowLeft className="me-1" /> Voltar
                </Button>
                <Button
                  size="lg"
                  onClick={() => navigate('/upgrade')}
                  style={{ backgroundColor: reqColor, borderColor: reqColor }}
                >
                  <FaRocket className="me-2" /> Fazer Upgrade
                </Button>
              </div>

            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
